import { createSlice } from "@reduxjs/toolkit";
import appApi from "../api";

type User = {
  cardNumber: string
  createdAt: string
  deleteAt: null | string
  email: string
  firstName: string
  id: string
  imageUrl: null | string
  lastName: string
  memberShipPlans: any[]
  membershipId: null | string
  offices: any[]
  phoneNumber: string
  userRentals: any[]
  userType: string
};

type SearchedUserState = {
  user: User;
  loading: boolean;
  error: string | null;
};

const initialState: SearchedUserState = {
  user: {} as User,
  loading: false,
  error: null,
};

const searchedUserSlice = createSlice({
  name: "searchedUser",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        appApi.endpoints.searchAUser.matchFulfilled,
        (state, action) => {
          state.user = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
  }
});
export const { setUser, } = searchedUserSlice.actions;
export default searchedUserSlice.reducer;
export const getSearchedUser = (state: { searchedUser: SearchedUserState }) => state.searchedUser.user;
// export const selectLoading = (state: { office: OfficeState }) => state.office.loading;
